import { useAdmin, usePermissions } from '@/utils/hooks'

interface PermissionsRequiredProps {
  permissions?: string | string[]
}

export const PermissionsRequired: React.JSX.CFC<PermissionsRequiredProps> = ({
  children,
  permissions,
}) => {
  const admin = useAdmin()
  const { hasPermissions } = usePermissions()

  if (typeof permissions === 'undefined') return <>{children}</>
  if (typeof permissions === 'string') permissions = [permissions]

  if (!admin && !hasPermissions(permissions)) return null

  return <>{children}</>
}
